import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["id", "required"];
const _hoisted_2 = {
  class: "image-input-container"
};
const _hoisted_3 = {
  class: "input-group-text image-form-control"
};
const _hoisted_4 = ["for"];
const _hoisted_5 = {
  key: 0,
  class: "image-container"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
import { watchEffect, ref, toRefs, getCurrentInstance, onMounted, computed } from 'vue';
import AppgInput from '@/components/custom/AppgInput.vue';
import Modal from '@/templates/argon-core/Modal';
import { getImagePath, toastAlert } from '@/common/utils/Util';
export default {
  __name: 'AppgImgInput',
  props: {
    label: {
      type: String,
      default: ''
    },
    span: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    fileUrl: {
      type: String,
      default: ''
    },
    initialLabel: {
      type: String,
      default: '파일을 첨부해주세요.'
    },
    valid: {
      type: Boolean,
      default: true
    },
    isDeleteButton: {
      type: Boolean,
      default: true
    },
    _class: {
      type: String,
      default: ''
    },
    inValidMessage: {
      type: String,
      default: ''
    },
    validSet: {
      type: Object,
      default: () => ({
        $error: false
      })
    },
    rawFile: {
      type: [File, null]
    },
    validFunction: {
      type: [Function, Object],
      default: null
    }
  },
  emits: ['change', 'remove', 'update:rawFile'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const {
      label,
      span,
      required,
      fileUrl,
      initialLabel,
      valid,
      isDeleteButton,
      _class,
      inValidMessage,
      validSet
    } = toRefs(props);
    const isModal = ref(false);
    const controlModal = () => {
      isModal.value = !isModal.value;
    };
    const UUID = ref(Math.floor(Math.random() * 9999));
    const file = computed({
      get: () => props.rawFile,
      set: val => emit('update:rawFile', val)
    });
    const previewSource = ref('');
    const changeFile = ({
      target
    }) => {
      let rawFile = target.files[0];
      if (!rawFile) return;
      if (!/image\/.*/.test(rawFile.type)) return;
      if (props.validFunction && props.validFunction(rawFile)) {
        toastAlert('JPG,PNG 파일만 등록가능합니다.', 'error');
        return false;
      }
      file.value = rawFile;
      emit('change', rawFile);
      let reader = new FileReader();
      reader.onload = e => {
        previewSource.value = e.target.result;
      };
      reader.readAsDataURL(rawFile);
      target.value = '';
    };
    const removeFile = () => {
      file.value = null;
      emit('remove');
    };
    const pathRenderer = url => {
      if (!url) return null;
      return getImagePath(url, 'origin');
    };
    return (_ctx, _cache) => {
      const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
      return _openBlock(), _createBlock(AppgInput, {
        label: _unref(label),
        valid: _unref(valid),
        span: _unref(span) ?? '',
        _class: _unref(_class),
        required: _unref(required),
        key: `container-${UUID.value}`,
        "in-valid-message": _unref(inValidMessage),
        "valid-set": _unref(validSet)
      }, {
        default: _withCtx(() => [_createElementVNode("input", {
          id: `file-input-${UUID.value}`,
          class: "custom-file-input",
          style: {
            "display": "none"
          },
          type: "file",
          required: _unref(required),
          accept: "image/*",
          onInput: changeFile
        }, null, 40, _hoisted_1), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_createVNode(_component_font_awesome_icon, {
          icon: ['far', 'image'],
          size: "2xl",
          class: "me-2"
        }), _createElementVNode("label", {
          class: "image-label",
          for: `file-input-${UUID.value}`
        }, _toDisplayString(file.value ? file.value.name : pathRenderer(_unref(fileUrl)) ?? _unref(initialLabel)), 9, _hoisted_4)]), _unref(fileUrl) || file.value ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createElementVNode("img", {
          onClick: controlModal,
          alt: "",
          class: "img-preview",
          src: !!previewSource.value ? previewSource.value : pathRenderer(_unref(fileUrl))
        }, null, 8, _hoisted_6), _unref(isDeleteButton) ?? true ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 512 512",
          class: "xmark",
          onClick: removeFile
        }, _cache[0] || (_cache[0] = [_createElementVNode("path", {
          d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        }, null, -1)]))) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_unref(Modal), {
          "show-close": true,
          show: isModal.value,
          size: "lg",
          onClose: controlModal
        }, {
          header: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("상세 보기")])),
          default: _withCtx(() => [_createElementVNode("img", {
            alt: "",
            src: !!previewSource.value ? previewSource.value : pathRenderer(_unref(fileUrl)),
            class: "image-modal-preview"
          }, null, 8, _hoisted_7)]),
          _: 1
        }, 8, ["show"])])]),
        _: 1
      }, 8, ["label", "valid", "span", "_class", "required", "in-valid-message", "valid-set"]);
    };
  }
};